import {
  DEFAULT_FEEDBACK_URL,
  IS_IE_BROWSER
} from '../common/config';

import {
  TYPE2CLASS
} from '../core/icon-class';
import {
  ticksFormat
} from '../common/datetime';
import {
  Fact
} from '../common/fact';

import {
  decoderElement,
  decoders,
} from './decode-fact';

import {
  decorateFaces
} from '../face/face.service.js';

const layout = {};

const unsortableFields = [
  'agent_dialog.contact',
  'agent_dialog.domain',
  'analytics_filter.name',
  'analytics_filter.category',
  'analytics_filter.syscat'
];

const entityMap = {
  '"': '&quot;',
  // '&': '&amp;', // с бакенда факты идут уже заменой "<" и ">" на '&lt;' и '&gt;'
  //  поэтому если подменять сивол '&' то ломается отображение "<" и ">"
  '\'': '&#39;',
  '/': '&#x2F;',
  '<': '&lt;',
  '>': '&gt;',
  '{': '{&#8205;',
  '}': '&#8205;}',
};

export const setShowSystemKeys = (options) => {
  layout.options = options;
  TimeCol.factKey = layout.options.timeRegistered.value ? 'time_registered' : 'local_time';
  TimeCol.label = layout.options.timeRegistered.value ? gettext('Серверное время') : gettext('Время');
};

const UserLogonEvents = {
  'UserLoggedOn': gettext('Вход в систему'),
  'UserLoggedOff': gettext('Выход из системы'),
  'UserSessionLocked': gettext('Сессия заблокирована'),
  'UserSessionUnlocked': gettext('Сессия разблокирована'),
};

const AppInstallationEvents = {
  'Install': gettext('Установка приложения'),
  'Deinstall': gettext('Удаление приложения'),
  'Inventory': gettext('Инвентаризация'),
};

function escapeHtml(string, notAllows = false) {
  if (string === null || typeof string !== 'string' || (string && string.trim && string.trim() === 'null')) return '';

  const allows = {
    '<b style="background-color: yellow">': 'fgksdroptipmhgasterte4589e5',
    "<b style='background-color: yellow'>": 'fgksdroptipmhgasterte4589e5',
    '</b>': 'sdfsdisdifoisdfiolsdafoewriu',
    '<highlight>': 'sjfowerogurthudrsoirtyhorttd',
    '</highlight>': 'dsfsdkfsdfsdflksdflksdfjsdlf',
    '<z0>': '0fdlgdsgkds;ldvkzfg;dsrgfdr',
    '</z0>': '0lkvbccl;gjfdgfsdndfg;nd',
    '<z1>': '1lcvkdfzogmikfdopgmidsgfijyd',
    '</z1>': '1fvgdzfrotspopobcsfsef5thf',
    '<z2>': '2cxmv;ifjndsriunsdinudsri',
    '</z2>': '2zdxcfsdefijsijgbicjfxgd',
    '<z3>': '3cvfmdxfjdsfjsfjdslk',
    '</z3>': '3htdklfkdhkmlsjfsdlfsdmlf',
    '<z4>': '4kgchjffgndfnfjrsdjnfgjn',
    '</z4>': '4klhfghghjncghgyhjukuhf',
    '<z5>': '5gfhndxzcfdszfgdghfghfcg',
    '</z5>': '5mhhgdgfdsgdgdfgfdsgdfzg',
    '<z6>': '6gfdgdrsfgdsfgdfgdfdfg',
    '</z6>': '6fdgkdslkljlflkfgjdsfsd',
    '<z7>': '7hdfsfd;dfgkdsdfgd',
    '</z7>': '7dgsddsfgfdsgfdsgdfg',
    '<z8>': '8fghsdstgvuiytdstte',
    '</z8>': '8bhdfrtyghdrjgyjgf',
  };

  Object.keys(allows).map(a => {
    const re = new RegExp(a, 'g');
    const s = notAllows ? '' : allows[a];
    string = string.replace(re, s);
  });

  string = string.replace(/[\{\}<>"'\/]/g, (s, i) => {
    return entityMap[s];
  });

  if (!notAllows) {
    Object.keys(allows).map(a => {
      const re = new RegExp(allows[a], 'g');
      string = string.replace(re, a);
    });
  }

  return string;
}

// Property widgets
export const AttachedFileProperty = function(fact) {

  const decorateNotExistsFiles = (val, fileName) => {
    let currentFilename = fileName || escapeHtml(fact['agent_attachedfile.file_name']) || '';
    if (currentFilename === 'null') {
      currentFilename = '';
    }
    const isFileExist = fact['agent_attachedfile.file_exist'];
    if (isFileExist) {
      return val;
    } else {
      const mimeType = fact['agent_attachedfile.mime'];
      const isLoaded = mimeType === 'not_loaded';
      const mainSpanClass = isLoaded ? 'unlinked' : 'broken';
      const iconClass = isLoaded ? 'icon-unlink' : 'icon-content-broken';
      const titleText = isLoaded ? gettext('Файл еще не загружен') : gettext('Файл удален');
      return '<span class="attfilelink ' + mainSpanClass + '" title="' + titleText + '">' +
        currentFilename +
        ' <i class="icon ' + iconClass + '"></i></span>';
    }
  };


  const eventName = fact['agent_eventtype.name'];
  if (fact['faces']) {
    let val = '<img ng-src="/analytics/thumb/' + escapeHtml(fact['agent_attachedfile.data']) +
      '" err-src="/static/img/default.png" ng-click="openImage(fact)" class="screenshot_thumb" />';
    val = decorateNotExistsFiles(val);
    val = decorateFaces(val, fact);
    return {
      key: gettext('Снимок'),
      val: val,
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'SystemLog' || eventName == 'LinuxLog') {
    const file_name = 'Debug_' + escapeHtml(fact['agent_agent.computer_name']) + '.zip';

    let val = '<span class="attfilelink">' + gettext('Скачать') +
      ' <a href="/media/' + fact['agent_attachedfile.data'] +
      '" target="_blank" download="' + file_name + '">' + file_name +
      ' <i class="icon icon-download"></i></a></span>';
    val = decorateNotExistsFiles(val, file_name);
    return {
      key: gettext('Контент'),
      val: val,
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'DesktopVideo') {
    let val =
      '<a class="btn" target="_new" href="/remote/?play=' + fact['agent_attachedfile.guid'] + '">' +
      '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] +
      '" err-src="/static/img/default.png" class="screenshot_thumb" />' +
      '</a>';

    const file_name = 'video' + fact['id'] + '.mp4';
    val = val + '<br><span class="attfilelink">' + gettext('Скачать') +
      ' <a href="/media/' + fact['agent_attachedfile.data'] +
      '" target="_blank" download="' + file_name + '" onclick="this.parentNode.remove()">' + file_name +
      ' <i class="icon icon-download"></i></a></span>';

    val = decorateNotExistsFiles(val);
    return {
      key: gettext('Контент'),
      val: val,
      fdim: 'agent_attachedfile@file_name:file_name',
      fval: fact['agent_attachedfile.file_name'],
      flbl: fact['agent_attachedfile.file_name'],
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'MicRecording' || fact['parentName'] == 'MicRecording') {
    let val = '';
    if (IS_IE_BROWSER) {
      val = '<sc-audio-file fact="fact" src="\'/media/\' + fact[\'agent_attachedfile.data\']"></sc-audio-file>';
    } else {
      val = '<sc-audio-waves fact="fact" src="\'/media/\' + fact[\'agent_attachedfile.data\']"></sc-audio-waves>';
    }
    val = decorateNotExistsFiles(val);
    return {
      key: gettext('Контент'),
      val: val,
      fdim: '',
      fval: '',
      flbl: '',
      class: 'important',
      bindable: true
    };
  } else {
    const file_name = escapeHtml(fact['agent_attachedfile.file_name']);
    // --------------------------------
    let val = '';
    if (Fact.isImage(fact)) {
      val = '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] +
        '" err-src="/static/img/default.png" ng-click="openImage(fact)" class="screenshot_thumb" /><br/>';
    }
    // --------------------------------
    val += '<span class="attfilelink">' + gettext('Скачать') +
      ' <a href="/media/' + fact['agent_attachedfile.data'] +
      '" target="_blank" download="' + file_name + '">' + file_name +
      ' <i class="icon icon-download"></i></a></span>';
    val = decorateNotExistsFiles(val);
    return {
      key: gettext('Контент'),
      val,
      fdim: 'agent_attachedfile@file_name:file_name',
      fval: fact['agent_attachedfile.file_name'],
      flbl: fact['agent_attachedfile.file_name'],
      class: 'important',
      bindable: true
    };
  }
};

const AttachedFileName = function(fact) {
  return {
    key: gettext('Имя файла'),
    val: escapeHtml(fact['agent_attachedfile.file_name']),
    fdim: 'agent_attachedfile@file_name:file_name',
    fval: fact['agent_attachedfile.file_name'],
    flbl: fact['agent_attachedfile.file_name'],
    class: 'important',
  };
};

const AttachedFilePath = function(fact) {
  return {
    key: gettext('Путь'),
    val: escapeHtml(fact['agent_attachedfile.file_path']),
    fdim: 'agent_attachedfile@file_path:file_path',
    fval: fact['agent_attachedfile.file_path'],
    flbl: fact['agent_attachedfile.file_path'],
    class: 'important',
  };
};

const SenderProperty = function(fact) {
  const sender = fact['agent_dialog.sender'];
  const dim = 'agent_dialog@sender:sender';
  const account = AccountHTML(escapeHtml(sender), fact, dim);
  return {
    key: gettext('Отправитель'),
    val: account,
    fdim: dim,
    fval: sender,
    flbl: sender,
    bindable: true,
  };
};

const AccountHTML = (accountKey, fact, dim) => {
  return fact.accounts && fact.accounts[accountKey] && fact.accounts[accountKey].length ?
    `<sc-account account-key="'${accountKey}'" dkey="'${dim}'" fact="fact"></sc-account>` :
    `<span data-key="${dim}" >${accountKey}</span>`;
};

const RecipientsProperty = function(fact) {
  const recipients = escapeHtml(fact['agent_dialog.recipients']);
  const dim = 'agent_dialog@recipients:recipients';
  return {
    key: gettext('Получатели'),
    val: escapeHtml(recipients).split(' ').map(a => AccountHTML(a, fact, dim)).join(' '),
    fdim: dim,
    fval: recipients,
    flbl: recipients,
    bindable: true,
  };
};
const MembersProperty = function(fact) {
  const members = fact['agent_dialog.members'];
  const sender = fact['agent_dialog.sender'];
  const recipients = fact['agent_dialog.recipients'];
  const dim = 'agent_dialog@members:members';
  const account = AccountHTML(escapeHtml(sender), fact, dim);
  return {
    key: gettext('Участники'),
    val: account && recipients ? account + ' ➤ ' + escapeHtml(recipients).split(' ')
      .map(a => AccountHTML(a, fact, dim)).join(' ') : '',
    fdim: dim,
    fval: members,
    flbl: members,
    class: 'important',
    bindable: true
  };
};
const NetworkConnectionProperty = function(fact) {
  let remote_address = escapeHtml(fact['agent_networkconnection.remote_address']);
  if (!remote_address) remote_address = '';
  let remote_port = escapeHtml(fact['agent_networkconnection.remote_port']);
  if (!remote_port) remote_port = '';
  return {
    key: gettext('Сетевая активность'),
    val: (remote_address && remote_port) ? remote_address + ':' + remote_port : '',
    fdim: 'agent_networkconnection@remote_address:remote_address',
    fval: remote_address,
    flbl: remote_address,
    class: 'important',
  };
};
const CallDurationProperty = function(fact) {
  let key = gettext('Длительность');
  if (fact['agent_eventtype.id'] === 11 ||
    fact['agent_eventtype.id'] === 0) key = gettext('Страниц');
  if (fact['agent_eventtype.id'] === 19) key = gettext('Количество');
  return {
    key,
    val: fact['call_duration'],
    class: 'important',
  };
};
const MessageFormatProperty = function(fact) {
  return {
    key: gettext('Формат'),
    val: escapeHtml(fact['agent_dialog.message_format']),
  };
};

const fixedString = function(s, wl) {
  const l = s.length;
  return l > wl + 5 ? s.slice(0, wl / 2) + '.. ..' + s.slice(l - wl / 2, l) : s;
};

const rewriteXML = text => {
  const startXML = text.match(/&lt;.xml\s+version\s*=.*&gt;/i);
  // console.log('startXML=', startXML);

  if (!startXML) return text;
  const endXML = text.match(/&gt;.*$/i);
  // console.log(startXML.index, endXML.index);
  // const xmlText = text.match(/&lt.*&gt;/gi);
  return text.substring(0, startXML.index) +
    '<div ng-click="showxml=!showxml" ><span class="pointer">' +
    gettext('Техническая информация (XML)') +
    '</span> <i ng-class="{\'icon-collapse\': !showxml, \'icon-uncollapse\': showxml, }"></i> <div ng-show="showxml">' +
    text.substring(startXML.index, (endXML.index + 4)) + '</div> </div>' +
    text.substring(endXML.index + 5);
};

export const TextProperty = function(fact, additionalElement) {

  const eventName = fact['agent_eventtype.name'];

  let textData = fact['text_data'].replace(/^[\s\n\r]*/gm, '');
  let bindable = true;
  let sval;
  if (eventName === 'FileOperation') {
    const wl = 40;
    textData = escapeHtml(textData);
    bindable = false;
    sval = textData.split('\n').reduce(function(a, b, c) {
      return a + (c == 0 && textData.indexOf('\n') != -1 ? '<b>' +
          gettext('Из') + '</b> ' : '') +
        (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + fixedString(
          b,
          wl,
        ) + (c === 0 ? ' ' : '');
    }, '');
    textData = textData.split('\n').reduce(function(a, b, c) {
      return a + (c == 0 && textData.indexOf('\n') != -1 ? '<b>' + gettext('Из') +
          '</b> ' : '') + (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + b +
        (c === 0 ? ' ' : '');
    }, '');
  } else {
    if (!layout || !layout.options ||
      !layout.options.showSystemKeys || !layout.options.showSystemKeys.value)
      if (fact['agent_eventtype.id'] == 1) {
        const originText = textData;
        const noBabgeText = textData.replace(/<badge>(?:.|\n)*?>/gm, '');
        textData = `<span class="hover-text">${originText}</span><span class="regular-text">${noBabgeText}</span>`;
      } else {
        textData = textData.replace(/<badge>(?:.|\n)*?>/gm, '');
      }
    sval = textData;
  }

  return {
    key: gettext('Содержимое'),
    val: `${textData}${additionalElement? additionalElement : ''}`,
    sval: sval,
    textFactId: fact.id,
    class: 'important',
    bindable: bindable
  };
};

const WebProperty = function(fact) {
  // const url = decodeURIComponent(fact['agent_web.url']);
  const url = fact['agent_web.url'];
  if (url === null || url === undefined) {
    return '';
  }
  return {
    key: gettext('Посещение сайта'),
    val: escapeHtml(url),
    fdim: 'agent_web@url:url',
    fval: escapeHtml(url),
    flbl: escapeHtml(url),
    // class: 'details',
    class: 'important',
  };
};
const SiteProperty = function(fact) {
  const domain = fact['agent_web.site'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key: gettext('Домен'),
    val: escapeHtml(domain),
    fdim: 'agent_web@site:site',
    fval: domain,
    flbl: domain,
    class: 'details',
  };
};


const FileSizeProperty = function(fact) {
  const bytes = fact['file_size'];
  let size = '';
  if (bytes >= 1000000) size = `${Math.round(bytes / 100000) / 10} Mb`;
  else if (bytes >= 1000) size = `${Math.round(bytes / 100) / 10} Kb`;
  else size = `${bytes} B`;

  return {
    key: gettext('Размер'),
    val: escapeHtml(size),
    fval: size,
    flbl: size,
    class: 'important',
  };
};


const DomainProperty = function(fact) {
  const domain = fact['agent_web.domain'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key: gettext('Сайт'),
    val: escapeHtml(domain),
    fdim: 'agent_web@domain:domain',
    fval: domain,
    flbl: domain,
    class: 'details',
  };
};

const TypeProperty = function(fact) {
  const eventName = fact['agent_eventtype.name'];
  let propClass = 'details';
  if (eventName === 'Stat') {
    propClass = 'important';
  }
  return {
    key: gettext('Тип события'),
    val: escapeHtml(fact['agent_eventtype.description']),
    fdim: 'agent_eventtype@default:agent_eventtype',
    fval: fact['agent_eventtype.id'],
    flbl: fact['agent_eventtype.description'],
    class: propClass,
    icon: TYPE2CLASS[fact['agent_eventtype.name']],
  };
};

const InstallationProductProperty = function(fact) {
  return {
    key: gettext('Продукт'),
    val: escapeHtml(fact['agent_appinstallation.product_name'] || ''),
    fdim: 'agent_appinstallation@product_name:product_name',
    fval: fact['agent_appinstallation.product_name'],
    flbl: fact['agent_appinstallation.product_name'],
    class: 'important',
  };
};

const InstallationPublisher = function(fact) {
  return {
    key: gettext('Поставщик'),
    val: escapeHtml(fact['agent_appinstallation.publisher'] || ''),
    fdim: 'agent_appinstallation@publisher:publisher',
    fval: fact['agent_appinstallation.publisher'],
    flbl: fact['agent_appinstallation.publisher'],
    class: 'important',
  };
};

const InstallationVersion = function(fact) {
  return {
    key: gettext('Версия'),
    val: escapeHtml(fact['agent_appinstallation.version'] || ''),
    fdim: 'agent_appinstallation@version:version',
    fval: fact['agent_appinstallation.version'],
    flbl: fact['agent_appinstallation.version'],
    class: 'important',
  };
};


const InstallationEventProperty = function(fact) {
  return {
    key: gettext('Операция'),
    val: AppInstallationEvents[fact['agent_appinstallation.install_event']],
    fdim: 'agent_appinstallation@install_event:install_event',
    fval: fact['agent_appinstallation.install_event'],
    flbl: fact['agent_appinstallation.install_event'],
    class: 'important',
  };
};
const FileOperationProperty = function(fact) {
  return {
    key: gettext('Операция'),
    val: escapeHtml(fact['agent_attachedfile.file_operation']),
    fdim: 'agent_attachedfile@file_operation:file_operation',
    fval: fact['agent_attachedfile.file_operation'],
    flbl: fact['agent_attachedfile.file_operation'],
    class: 'important',
  };
};
const LogonProperty = function(fact) {
  return {
    key: gettext('Вход в систему'),
    val: escapeHtml(UserLogonEvents[fact['logon_event']] || fact['logon_event'].split(';')[0]),
    fdim: 'logon_event',
    fval: fact['logon_event'],
    flbl: UserLogonEvents[fact['logon_event']] || fact['logon_event'],
    class: 'important',
    icon: TYPE2CLASS[fact['logon_event']],
  };
};
const WindowTitleProperty = function(fact) {
  return {
    key: gettext('Заголовок окна'),
    val: escapeHtml(fact['window_title']),
    fval: fact['window_title'],
    flbl: fact['window_title'],
    fdim: 'agent_application@window_title:window_title',
    class: 'window-title',
  };
};
const ComputerProperty = function(fact) {
  return {
    key: gettext('Агент'),
    val: escapeHtml(fact['agent_agent.computer_name']),
    fdim: 'agent_agent@computer_name:computer_name',
    fval: fact['agent_agent.id'],
    flbl: fact['agent_agent.computer_name'],
    fval2: fact['agent_agent.guid'],
  };
};

const AccountProperty = function(fact) {
  if (fact['agent_account.user_name']) {
    return {
      key: gettext('Пользователь'),
      val: escapeHtml(fact['agent_account.user_name']),
      fdim: 'agent_account@user_name:user_name',
      fval: fact['agent_account.user_name'],
      flbl: fact['agent_account.user_name'],
    };
  } else if (fact['logon_event']) {
    return {
      key: gettext('Пользователь'),
      val: escapeHtml(fact['logon_event'].split(';')[0]),
      fdim: 'logon_event',
      fval: fact['logon_event'],
      flbl: fact['logon_event'],
    };
  }
};

const DeviceManufacturerProperty = function(fact) {
  return {
    key: gettext('Производитель'),
    val: escapeHtml(fact['agent_device.manufacturer']),
    fdim: 'agent_device@manufacturer:manufacturer',
    fval: fact['agent_device.manufacturer'],
    flbl: fact['agent_device.manufacturer'],
    class: 'important',
  };
};
const DeviceDescriptionProperty = function(fact) {
  return {
    key: gettext('Устройство'),
    val: escapeHtml(fact['agent_device.description']),
    fdim: 'agent_device@description:description',
    fval: fact['agent_device.description'],
    flbl: fact['agent_device.description'],
  };
};
const DeviceHWIDProperty = function(fact) {
  return {
    key: gettext('HardwareId'),
    val: escapeHtml(fact['agent_device.hwid']),
    fdim: 'agent_device@hwid:hwid',
    fval: fact['agent_device.hwid'],
    flbl: fact['agent_device.hwid'],
  };
};
const DriveTypeProperty = function(fact) {
  return {
    key: gettext('Тип устройства'),
    val: escapeHtml(fact['agent_device.drive_type']),
    fdim: 'agent_device@drive_type:drive_type',
    fval: fact['agent_device.drive_type'],
    flbl: fact['agent_device.drive_type'],
  };
};
const FeedbackProperty = function(fact) {
  return {
    key: gettext('Статус'),
    val: escapeHtml(fact['agent_feedbacktype.name']),
    fdim: 'agent_feedbacktype@default:agent_feedbacktype',
    fval: fact['agent_feedbacktype.id'],
    flbl: fact['agent_feedbacktype.name'],
  };
};
const ParentProperty = function(fact) {
  return {
    key: gettext('Источник'),
    val: escapeHtml(fact['parent.event_type_name']) + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['parent_id'],
    flbl: fact['parent_id'],
    bindable: true
  };
};
const ChildrenProperty = function(fact) {
  return {
    key: gettext('Источник'),
    val: escapeHtml(fact['agent_eventtype.name']) + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['id'],
    flbl: fact['id'],
    bindable: true
  };
};
const TriggeredFilterProperty = function(fact) {
  const value_value = fact ? (
    fact['analytics_filter.name'] ? escapeHtml(fact['analytics_filter.name']) : gettext('Все события')) : '';
  return {
    key: gettext('Фильтр'),
    val: value_value,
    fdim: 'analytics_filter@name:name',
    fval: value_value,
    flbl: value_value,
    class: 'important',
  };
};
const CommentProperty = function(fact) {
  const val = fact['agent_account.comment'];
  return {
    key: gettext('Комментарий'),
    val: escapeHtml(val),
    class: 'important',
  };
};
const FeedbackDescriptionProperty = function(fact) {
  return {
    key: gettext('Алерт'),
    val: escapeHtml(fact['agent_feedbacktype.description']),
    fdim: 'agent_feedbacktype@default:agent_feedbacktype',
    fval: fact['agent_feedbacktype.id'],
    flbl: fact['agent_feedbacktype.description'],
    class: 'important',
  };
};

const UserActiveColProperty = (fact) => {
  const val = ticksFormat(fact['activity_time'], true);
  if (val) return {
    key: gettext('Длительность'),
    val: val,
    fval: val,
    flbl: val,
  };
  else return null;
};

export const localTimeProperty = (fact) => {
  const val = dateFiler(fact[layout.options.timeRegistered.value ? 'time_registered' : 'local_time'],
    'yyyy-MM-dd HH:mm:ss') + ' ' + timezone(fact);

  return {
    key: layout.options.timeRegistered.value ? gettext('Серверное время') : gettext('Время'),
    val: val,
    fval: fact.id,
    flbl: fact.id,
    fdim: 'id@default:id',
    class: 'important',
  };
};

const applicationProperty = function(fact) {
  return {
    key: gettext('Приложение'),
    val: escapeHtml(fact['agent_application.app_name']),
    fval: fact['agent_application.app_name'],
    flbl: fact['agent_application.app_description'],
    fdim: 'agent_application@app_name:app_name',
    icon: '/analytics/icon/' + fact['agent_application.app_icon_id'],
  };
};

const ProcessIdProperty = function(fact) {
  const val = escapeHtml(fact['process_id']);
  return {
    key: gettext('PID'),
    val: val,
    class: 'important',
  };
};

const UserSessionIdProperty = function(fact) {
  const val = escapeHtml(fact['user_session_id']);
  return {
    key: gettext('UID'),
    val: val,
    class: 'important',
  };
};

const ClipboardFormatProperty = function(fact) {
  const val = fact['clipboard_format'];
  const format = {
    0: gettext('Не определен'),
    1: gettext('Текст'),
    2: gettext('Изображение'),
    3: gettext('Файл')
  };
  return {
    key: gettext('Формат буфера обмена'),
    val: format[val],
    class: 'important',
  };
};

export const ATTR2PROP = {
  'local_time': localTimeProperty,
  'agent_dialog.members': MembersProperty,
  'window_title': WindowTitleProperty,
  'text_data': TextProperty,
  'agent_attachedfile.data': AttachedFileProperty,
  'agent_application.app_name': applicationProperty,
  'analytics_filter.name': TriggeredFilterProperty,
  'agent_feedbacktype.name': FeedbackProperty,
  'agent_eventtype.description': TypeProperty,
  'agent_agent.computer_name': ComputerProperty,
  'agent_account.user_name': AccountProperty,
  'agent_attachedfile.file_name': AttachedFileName,
  'agent_attachedfile.file_path': AttachedFilePath,
  'agent_attachedfile.file_operation': FileOperationProperty,
  'agent_networkconnection.remote_address': NetworkConnectionProperty,
  'agent_dialog.sender': SenderProperty,
  'agent_dialog.recipients': RecipientsProperty,
  'call_duration': CallDurationProperty,
  'agent_dialog.message_format': MessageFormatProperty,
  'agent_web.url': WebProperty,
  'agent_web.site': SiteProperty,
  'agent_web.domain': DomainProperty,
  'logon_event': LogonProperty,
  'agent_appinstallation.install_event': InstallationEventProperty,
  'agent_appinstallation.product_name': InstallationProductProperty,
  'agent_appinstallation.publisher': InstallationPublisher,
  'agent_appinstallation.version': InstallationVersion,
  'agent_device.manufacturer': DeviceManufacturerProperty,
  'agent_device.description': DeviceDescriptionProperty,
  'agent_device.hwid': DeviceHWIDProperty,
  'agent_device.drive_type': DriveTypeProperty,
  'parent_id': ParentProperty,
  'children_id': ChildrenProperty,
  'agent_feedbacktype.description': FeedbackDescriptionProperty,
  'activity_time': UserActiveColProperty,
  'agent_account.comment': CommentProperty,
  'process_id': ProcessIdProperty,
  'user_session_id': UserSessionIdProperty,
  'clipboard_format': ClipboardFormatProperty,
  'file_size': FileSizeProperty,
};

const IMPATTR2PROP = [
  'agent_feedbacktype.description',
  'agent_dialog.sender',
  'window_title',
  'text_data',
  'analytics_filter.name',
  'agent_attachedfile.file_operation',
  'agent_attachedfile.file_name',
  'agent_attachedfile.data',
  'agent_networkconnection.remote_address',
  'logon_event',
  'agent_appinstallation.install_event',
  'agent_appinstallation.product_name',
  'agent_device.drive_type',
  'agent_device.description',
  'parent_id',
];

// ///////////////////
// For Table View !!!

export const dateFiler = (x, y) => {
  if (x == undefined) return '';
  return x.toString().replace('T', ' ')
    .substring(0, 19);
};

// Build Icon
export const makeIcon = function(icon) {
  if (icon && icon[0] == '/') {
    icon = '<img class="widget-icon" src="' + icon + '"/>';
  } else if (icon) {
    icon += ' widget-icon';
    icon = icon && '<span class="' + icon + '"></span>';
  } else {
    icon = '';
  }
  return icon;
};
// Build filter attrs
export const makeFilterAttrs = function(dimension, dim_key, dim_label) {
  let filterAttrs = '';
  if (dimension) {
    const fdim = dimension;
    const fval = typeof dim_key === 'string'? escapeHtml((dim_key == undefined | dim_key == null) ? '' : dim_key, true): dim_key;
    const flbl = typeof dim_label === 'string'? escapeHtml(dim_label ? dim_label : '', true): dim_label;
    filterAttrs = ` class="widget-filter" data-key="${fdim}" data-value="${fval}"  data-label="${flbl}"`;
  } else {
    filterAttrs = ' class="widget-data"';
  }
  return filterAttrs;
};

// Build cell from property
const cellFromProp = function(prop, mode) {
  if (!prop) return '';
  const icon = makeIcon(prop.icon);
  const bindable = prop.bindable ? '' : ' ng-non-bindable ';
  if (mode === 'extended') {
    return '<span' + bindable + makeFilterAttrs(
      prop.fdim,
      prop.fval,
      prop.flbl,
    ) + ' ng-bind-html="trustAsHtml(textData)"></span>';
  }
  const valueText = ((mode === 'short' && prop.sval) ? prop.sval : prop.val) || '';
  return '<span' + bindable + makeFilterAttrs(
    prop.fdim,
    prop.fval,
    prop.flbl,
  ) + '>' + icon + ' ' + valueText + '</span>';
};

export const widgetFromProp = function(prop) {
  if (!prop) return '';
  const icon = makeIcon(prop.icon);
  const prop_class = prop.class ? prop.class : 'details';
  const bindable = prop.bindable ? '' : ' ng-non-bindable ';

  const txtRemote = gettext('Удалённый рабочий стол');
  const txtCopy = gettext('Скопировать в буфер обмена');
  const txtGoto = gettext('Перейти к тексту факта');
  const txtConfig = gettext('Конфигурация агента');
  const txtProfile = gettext('Профиль агента');
  const txtSchedule = gettext('Назначение расписания');

  const res = '<div class="row-fluid widget-property ' + prop_class + '">' +
    '<span class="widget-label">' + prop.key + '</span>' +
    '<span class="widget-value">' + icon + '<span' + bindable +
    makeFilterAttrs(prop.fdim, prop.fval, prop.flbl) + '>' +
    prop.val +
    '</span>' +
    (prop.fdim === 'agent_agent@computer_name:computer_name' ?
      '<i class="icon-desktop widget-icon" ' +
      'ng-class="{\'remote-active\': isRemote(), \'remote-passive\': !isRemote()}" ' +
      'ng-click="connectRemoteUser($event)" ' +
      'title="' + txtRemote + '"></i>' +

      (prop.fval2 ? `<a ng-href="/agent/edit_config/?agent=${prop.fval2}" target="_blank">` +
        '<i class="icon-cog widget-icon" ' +
        'title="' + txtConfig + '"></i></a>' : '') +

      `<a ng-href="/admin/agent/agent/${prop.fval}/" target="_blank">` +
      '<i class="icon-t-shirt widget-icon" ' +
      'title="' + txtProfile + '"></i></a>' +

      `<a ng-href="/admin/work_calendar/weekscheduledimension/add/?dimension=${prop.fdim}&value=${prop.val}" target="_blank">` +
      '<i class="icon-clock-1 widget-icon" ' +
      'title="' + txtSchedule + '"></i></a>'

      :
      ''
    ) +
    '<span class="copy-clippboard " title="' + txtCopy + '">' +
    '<span class="icon-docs widget-icon" ng-click="copyToClippboard($event)"></span>' +
    (prop.textFactId ?
      '<a target="_new" href="/analytics/text/?id=' + prop.textFactId.toString() +
      '" title="' + txtGoto +
      '"><i class="icon-download-1"></i></a>' : ''
    ) +
    '</span></span></div>';
    return res;
};


export function buildWidget(fact) {
  if (!fact) return;

  // Event widget start
  let widget = '<div ng-click="collapse()" class="widget-body"><div class="widget-properties">';
  // Build properties
  for (const k in ATTR2PROP) {
    if (fact && fact[k]) {
      widget += widgetFromProp(ATTR2PROP[k](fact));
    }
  }

  if (fact && fact.children) {
    widget += fact.children.map(function(ch) {
      ch['parentName'] = fact['agent_eventtype.name'];
      return ch['agent_attachedfile.data'] ? widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
    }).join('');
  }

  widget += '</div>';
  widget += '<div class="widget-menu"><i ng-class="{\'icon-collapse\': isCollapsed, \'icon-uncollapse\': !isCollapsed}"></i></div>';
  widget += '<div class="clearfix"/></div>';
  return widget;
}

// //////////////////////////////////////////////////////////////////////////
// Build data
const parseMinutesTz = (tz) => {
  if (!tz) return 0;
  const i = tz.indexOf('UTC');
  if (i !== -1) tz = tz.substring(i + 3);
  let min = 0;
  let hours = 0;
  const arrTz = tz.split(':');
  hours = parseInt(arrTz[0], 10);
  min = arrTz[1] ? parseInt(arrTz[1], 10) : 0;

  if (isNaN(hours)) hours = 0;
  if (isNaN(min)) min = 0;
  const sign = hours < 0 ? -1 : 1;
  return hours * 60 + min * sign;
};

const timezone = (fact) => {
  if (!fact['local_time']) return 0;
  // console.log(fact['local_time']);
  const agentTz = parseMinutesTz(fact['agent_time.time_zone']);
  const localTime = fact['local_time'];
  const localTz = parseMinutesTz(localTime.substring(localTime.length - 6));
  if (agentTz === localTz) return '';
  const sign = agentTz > localTz ? 1 : -1;
  const dif = (agentTz - localTz) * sign;
  const hours = (sign == 1 ? '+' : '-') + (~~(dif / 60));
  let minutes = dif % 60;
  minutes = minutes ? ':' + minutes : '';

  return hours + minutes;
};

const TimeCol = {
  factKey: 'local_time',
  label: gettext('Время'),
  cssClass: 'fact-time',
  parse: function(fact) {
    return fact ? cellFromProp(ATTR2PROP['local_time'](fact)) : '';
  },
  sortable: true,
};

const TypeCol = {
  factKey: 'agent_eventtype.description',
  'label': gettext('Тип'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_eventtype.description'](fact)) : '';
  },
  'dim': 'agent_eventtype@default:agent_eventtype',
  sortable: true,
};

const ComputerCol = {
  factKey: 'agent_agent.computer_name',
  'label': gettext('Компьютер'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact)) : '';
  },
  'dim': 'agent_agent@computer_name:computer_name',
  sortable: true,
};

const OwnerCol = {
  factKey: 'agent_agent.computer_name',
  'label': gettext('Владелец'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact)) : '';
  },
  'dim': 'agent_agent@computer_name:computer_name',
  sortable: true,
};

const UserCol = {
  factKey: 'agent_account.user_name',
  'label': gettext('Пользователь'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_account.user_name'](fact)) : '';
  },
  'dim': 'agent_account@user_name:user_name',
  sortable: true,
};

const UserSessionIdCol = {
  factKey: 'user_session_id',
  'label': gettext('ID пользовательской сессии '),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['user_session_id'](fact)) : '';
  },
  sortable: false,
};

const ProcessIdCol = {
  factKey: 'process_id',
  'label': gettext('ID процесса'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['process_id'](fact)) : '';
  },
  sortable: false,
};

const ClipboardFormatCol = {
  factKey: 'clipboard_format',
  'label': gettext('Формат буфера обмена'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['clipboard_format'](fact)) : '';
  },
  sortable: true,
};

const WebCol = {
  factKey: 'agent_web.url',
  'label': gettext('Ссылка'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.url'](fact)) : '';
  },
  sortable: true,
};

const SiteCol = {
  factKey: 'agent_web.site',
  'label': gettext('Домен'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.site'](fact)) : '';
  },
  sortable: true,
};
const DomainCol = {
  factKey: 'agent_web.domain',
  'label': gettext('Сайт'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.domain'](fact)) : '';
  },
  sortable: true,
};
const AppCol = {
  factKey: 'agent_application.app_name',
  'label': gettext('Приложение'),
  'parse': function(fact) {

    const app_icon = makeIcon('/analytics/icon/' + (fact ? fact['agent_application.app_icon_id'] : ''));
    const app_name = fact ? fact['agent_application.app_name'] : '';
    return app_name ? '<span' +
      makeFilterAttrs(
        'agent_application@app_name:app_name',
        app_name,
        app_name,
      ) +
      '>' + app_icon + app_name + '</span>' : '';
  },
  'dim': 'agent_application@app_name:app_name',
  sortable: true,
};
const TitleCol = {
  factKey: 'window_title',
  'label': gettext('Заголовок'),
  'cssClass': 'fact-wide',
  'parse': function(fact) {
    return fact ? (fact['window_title'] ? cellFromProp(ATTR2PROP['window_title'](fact)) : '') : '';
  },
  sortable: true,
};
const FileOperationTypeCol = {
  factKey: 'agent_attachedfile.file_operation',
  'label': gettext('Операция'),
  'parse': function(fact) {
    return fact ? (fact['agent_attachedfile.file_operation'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_operation'](fact)) : '') : '';
  },
  sortable: true,
};
const FileOperationCol = {
  factKey: 'text_data',
  'label': gettext('Описание'),
  'parse': function(fact) {
    return !fact['agent_attachedfile.file_path'] || fact['text_data'] && fact['text_data'].indexOf('\n') != -1 ? cellFromProp(ATTR2PROP['text_data'](fact)) : '';
  },
  sortable: false,
};
const ExtraCol = {
  factKey: 'text_data',
  'label': gettext('Дополнительно'),
  'parse': function(fact) {
    return fact ? (fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact)) : '') : '';
  },
  sortable: false,
};

const TextCol = {
  factKey: 'text_data',
  'label': gettext('Текст'),
  'cssClass': 'fact-wide',
  'parse': function(fact, mode) {
    return fact ? (fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '') : '';
  },
  sortable: true,
};

const KeyboardTextCol = {
  factKey: 'text_data',
  'label': gettext('Текст'),
  'cssClass': 'fact-wide',
  'parse': function(fact, mode) {
    return fact ? cellFromProp(ATTR2PROP['text_data'](fact, mode)) : '';
  },
  sortable: false,
};

const NetCol = {
  factKey: 'agent_networkconnection.remote_address',
  'label': gettext('Сокет'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_networkconnection.remote_address'](fact)) : '';
  },
  sortable: true,
};

const SenderCol = {
  factKey: 'agent_dialog.sender',
  'label': gettext('Отправитель'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_dialog.sender'](fact)) : '';
  },
  sortable: true,
};
const RecipientsCol = {
  factKey: 'agent_dialog.recipients',
  'label': gettext('Получатели'),
  'parse': fact => {
    if (!fact) return '';
    const recipients = fact['agent_dialog.recipients'] ? cellFromProp(ATTR2PROP['agent_dialog.recipients'](fact)) : '';
    const breakLine = fact['agent_dialog.recipients'] && fact['agent_web.url'] ? '<br>' : '';
    const url = fact['agent_web.url'] ? cellFromProp(ATTR2PROP['agent_web.url'](fact)) : '';
    return `${recipients}${breakLine}${url}`;
  },
  sortable: true,
};
const ImMessageCol = {
  factKey: 'text_data',
  'label': gettext('Сообщение'),
  'cssClass': 'fact-wide',
  'parse': function(fact, mode) {
    return fact ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '';
  },
  sortable: false,
};
const InstallEventCol = {
  factKey: 'agent_appinstallation.install_event',
  'label': gettext('Операция'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.install_event'](fact)) : '';
  },
  'dim': 'agent_appinstallation@install_event:install_event',
  sortable: true,
};
const InstallProductCol = {
  factKey: 'agent_appinstallation.install_event',
  'label': gettext('Продукт'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.product_name'](fact)) : '';
  },
  'dim': 'agent_appinstallation@product_name:product_name',
  sortable: true,
};

const InstallPublisherCol = {
  factKey: 'agent_appinstallation.publisher',
  'label': gettext('Поставщик'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.publisher'](fact)) : '';
  },
  'dim': 'agent_appinstallation@publisher:publisher',
  sortable: true,
};

const InstallVersionCol = {
  factKey: 'agent_appinstallation.version',
  'label': gettext('Версия'),
  'parse': function(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.version'](fact)) : '';
  },
  'dim': 'agent_appinstallation@version:version',
  sortable: true,
};

const AttachedFileNameCol = {
  factKey: 'agent_attachedfile.file_name',
  'label': gettext('Имя файла'),
  'parse': function(fact) {
    return fact ? (fact['agent_attachedfile.file_name'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_name'](fact)) : '') : '';
  },
  sortable: true,
};

const AttachedFilePathCol = {
  factKey: 'agent_attachedfile.file_path',
  'label': gettext('Путь'),
  'parse': function(fact) {
    return fact ? (fact['agent_attachedfile.file_path'] ?
      cellFromProp(ATTR2PROP['agent_attachedfile.file_path'](fact)) : '') : '';
  },
  sortable: true,
};

const AttachedFileCol = {
  factKey: 'agent_attachedfile.data',
  'label': gettext('Контент'),
  'cssClass': 'fact-wide',
  'parse': function(fact) {
    if (fact && fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact && fact.children) {
      return fact.children.map(function(ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        const linkToChildren = ch['id'] ? cellFromProp(ATTR2PROP['children_id'](ch)) : '';
        return ch['agent_attachedfile.data'] ?
          cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) + linkToChildren : '';
      }).join('');
    }
    return '';
  },
  sortable: true,
};

const ScreenshotCol = {
  factKey: 'agent_attachedfile.data',
  'label': gettext('Снимок'),
  'cssClass': 'fact-wide',
  'parse': function(fact) {
    if (fact && fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact && fact.children) {
      return fact.children.map(function(ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        return ch['agent_attachedfile.data'] ?
          cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
      }).join('');
    }
    return '';
  },
  sortable: true,
};

const DeviceManufacturerCol = {
  factKey: 'agent_device.manufacturer',
  'label': gettext('Тип'),
  'parse': function(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_device.manufacturer'](fact));
  },
  sortable: true,
};

const DeviceDescriptionCol = {
  factKey: 'agent_device.description',
  'label': gettext('Устройство'),
  'parse': function(fact) {
    if (!fact) return '';
    return fact['agent_device.description'] ?
      cellFromProp(ATTR2PROP['agent_device.description'](fact)) : '';
  },
  sortable: true,
};

const DeviceHWIDCol = {
  factKey: 'agent_device.hwid',
  'label': gettext('ID'),
  'parse': function(fact) {
    if (!fact) return '';
    return fact['agent_device.hwid'] ?
      cellFromProp(ATTR2PROP['agent_device.hwid'](fact)) : '';
  },
  sortable: true,
};

const DriveTypeCol = {
  factKey: 'agent_device.drive_type',
  'label': gettext('Тип устройства'),
  'parse': function(fact) {
    if (!fact) return '';
    return fact['agent_device.drive_type'] ?
      cellFromProp(ATTR2PROP['agent_device.drive_type'](fact)) : '';
  },
  sortable: true,
};

const LogonCol = {
  factKey: 'logon_event',
  'label': gettext('Событие'),
  'parse': function(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['logon_event'](fact));
  },
  'dim': 'logon_event@default:logon_event',
  sortable: true,
};

const AmountCol = {
  factKey: 'call_duration',
  'label': gettext('Количество'),
  'parse': function(fact) {
    if (!fact) return '';
    return fact['call_duration'];
  },
  sortable: true,
};

const PriceCol = {
  factKey: 'activity_time',
  'label': gettext('Цена'),
  'parse': function(fact) {
    return fact['activity_time'];
  },
  sortable: true,
};

const TotalPagesCol = {
  factKey: 'call_duration',
  'label': gettext('Страницы'),
  'cssClass': 'fact-center',
  'parse': function(fact) {
    return cellFromProp(ATTR2PROP['call_duration'](fact));
  },
  sortable: true,
};

const FileSizeCol = {
  factKey: 'file_size',
  'label': gettext('Размер'),
  'cssClass': 'fact-center',
  'parse': function(fact) {
    return cellFromProp(ATTR2PROP['file_size'](fact));
  },
  sortable: true,
};

const EventCol = {
  factKey: 'text_data',
  'label': gettext('Событие'),
  'cssClass': 'fact-wide',
  'parse': fact => {
    if (!fact) return;
    const cut_text_data = ['InterceptedFile', 'Im', 'Mail', 'Screenshot', 'File', 'Clipboard'].indexOf(fact['agent_eventtype.name']) >= 0;
    let w = IMPATTR2PROP.map(attr => {
      if (!fact[attr]) return '';
      if (attr == 'text_data' && cut_text_data) {
        const regex = /(<([^>]+)>)/ig;
        const text = fact[attr].replace(regex, '').replace(/\s\s+/, ' ');
        if (text.length > 128) return text.substring(0, 128) + '...';
        return text;
      }
      if (attr == 'text_data' && fact['text_data'].match(/<[^>]+<b style='background-color: yellow'/gi)) {
        fact['text_data'] = escapeHtml(fact['text_data']);
      }

      return cellFromProp(ATTR2PROP[attr](fact));
    }).join('');

    fact && fact.children ?
      fact.children.forEach(ch => {
        ch['parentName'] = fact['agent_eventtype.name'];
        w += IMPATTR2PROP.map(attr => ch[attr] ? cellFromProp(ATTR2PROP[attr](ch)) : '')
          .join('');
      }) : null;
    return w;
  },
  sortable: false,
};

const UserActiveCol = {
  factKey: 'activity_time',
  'cssClass': 'fact-time',
  'label': gettext('Длительность'),
  'parse': function(fact) {
    return fact ? ticksFormat(fact['activity_time'], true) : '';
  },
  sortable: true,
};

const FeedbackCol = {
  factKey: 'agent_feedbacktype.name',
  'label': gettext('Статус'),
  'parse': function(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_feedbacktype.name'](fact));
  },
  sortable: true,
};

const BacklinkCol = {
  factKey: 'window_title',
  'label': gettext('Ссылка'),
  'parse': function(fact) {
    if (!fact) return '';
    return '<a href=\'' + DEFAULT_FEEDBACK_URL +
      fact['window_title'] + '\' target=\'_new\'>' +
      fact['window_title'] + '</a>';
  },
  sortable: true,
};

const CommentCol = {
  factKey: 'agent_account.comment',
  'label': gettext('Комментарий'),
  'parse': function(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_account.comment'](fact));
  },
  sortable: true,
};

const ParentCol = {
  factKey: 'parent_id',
  'label': gettext('Связано с'),
  'parse': function(fact) {
    if (!fact) return '';
    return fact['parent_id'] ? cellFromProp(ATTR2PROP['parent_id'](fact)) : '';
  },
  sortable: true,
};

const IdleTimeCol = {
  factKey: 'idle_time',
  'label': gettext('Время'),
  'cssClass': 'fact-time',
  'parse': function(fact) {
    return fact ? ticksFormat(fact['idle_time']) : '';
  },
  sortable: true,
};

const FeedbackDescriptionCol = {
  factKey: 'agent_feedbacktype.description',
  'label': gettext('Алерт'),
  'parse': function(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_feedbacktype.description'](fact));
  },
  sortable: true,
};

const WLanCol = {
  factKey: 'text_data',
  'label': gettext('SSID'),
  'cssClass': 'fact-wide',
  'parse': function(fact, mode) {
    return fact ? (fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '') : '';
  },
  sortable: false,
};
// TableViews

const tableViews = [{
    'name': 'BaseTable',
    'columns': [TimeCol, TypeCol, ComputerCol, UserCol, AppCol, EventCol],
    'important': [EventCol],
    'colwidths': [.1, .1, .1, .1, .1, .5],
  }, {
    'name': 'BaseTableOneEvet',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, EventCol],
    'important': [EventCol],
    'colwidths': [.1, .1, .1, .1, .5],
  },
  {
    'name': 'Keyboard',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, TitleCol, TextCol],
    'important': [AppCol, TitleCol, WebCol, KeyboardTextCol],
    'colwidths': [.1, .1, .1, .1, .3, .3],
  }, {
    'name': 'AppRun',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, ProcessIdCol, UserSessionIdCol],
    'important': [AppCol, TitleCol, ProcessIdCol, UserSessionIdCol],
  }, {
    'name': 'AppActiv',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, TitleCol, ProcessIdCol, UserSessionIdCol],
    'important': [AppCol, TitleCol, TextCol, DomainCol, WebCol, ProcessIdCol, UserSessionIdCol],
  }, {
    'name': 'Screenshot',
    'columns': [TimeCol, ComputerCol, UserCol, TitleCol, ScreenshotCol],
    'important': [AppCol, TitleCol, WebCol, ScreenshotCol],
    'colwidths': [.1, .1, .1, .2, .3],
  }, {
    'name': 'WebcamSnapshot',
    'columns': [TimeCol, ComputerCol, UserCol, ScreenshotCol],
    'important': [UserCol, ScreenshotCol],
    'colwidths': [.1, .1, .1, .7],
  }, {
    'name': 'MicRecording',
    'columns': [
      TimeCol, ComputerCol, UserCol, AttachedFileCol, //DeviceDescriptionCol
    ],
    'important': [AttachedFileCol],
    'colwidths': [.1, .1, .1, .3],
  }, {
    'name': 'Net',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, NetCol],
    'important': [NetCol, AppCol],
  }, {
    'name': 'Install',
    'columns': [
      TimeCol, ComputerCol,
      InstallEventCol, InstallProductCol, //InstallPublisherCol, InstallVersionCol
    ],
    'important': [InstallEventCol, InstallProductCol],
  }, {
    'name': 'Install2',
    'columns': [
      TimeCol, ComputerCol,
      InstallEventCol, InstallProductCol, InstallPublisherCol, InstallVersionCol
    ],
    'important': [InstallEventCol, InstallProductCol],
  }, {
    'name': 'Web',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, WebCol],
    'important': [AppCol, DomainCol, TitleCol, WebCol, AttachedFileCol],
    'colwidths': [.1, .1, .1, .1, .3],
  }, {
    'name': 'Im',
    'columns': [
      TimeCol, ComputerCol, UserCol, SenderCol,
      RecipientsCol, ImMessageCol,
    ],
    'important': [
      SenderCol, RecipientsCol,
      TitleCol, ImMessageCol,
    ],
    'colwidths': [.1, .1, .1, .1, .1, .5],
  }, {
    'name': 'Mail',
    'columns': [
      TimeCol, ComputerCol, UserCol, SenderCol,
      RecipientsCol, TitleCol,
    ],
    'important': [
      SenderCol, RecipientsCol, TitleCol,
      AttachedFileCol, ImMessageCol,
    ],
    'colwidths': [.1, .1, .1, .1, .1, .4, ],
  }, {
    'name': 'PrintDoc',
    'columns': [
      TimeCol, ComputerCol, UserCol, TotalPagesCol,
      TextCol, AttachedFileCol,
    ],
    'important': [TextCol, AttachedFileCol, TotalPagesCol],
    'colwidths': [.1, .1, .1, .1, .3, .3],
  }, {
    'name': 'Clipboard',
    'columns': [
      TimeCol, ComputerCol, UserCol,
      AppCol, TextCol, AttachedFileCol, ClipboardFormatCol,
    ],
    'important': [TextCol, AttachedFileCol],
    'colwidths': [.1, .1, .1, .1, .1, .3, .1],
  }, {
    'name': 'Logon',
    'columns': [TimeCol, ComputerCol, UserCol, LogonCol],
    'important': [LogonCol],
  }, {
    'name': 'Device',
    'columns': [
      TimeCol, ComputerCol, UserCol, DeviceManufacturerCol,
      DeviceDescriptionCol, DeviceHWIDCol, //ExtraCol,
    ],
    'important': [
      DeviceManufacturerCol, DeviceDescriptionCol,
      DeviceHWIDCol, //ExtraCol,
    ],
    'colwidths': [.1, .1, .1, .1, .1, .2],
  }, {
    'name': 'DevInventory',
    'columns': [
      TimeCol, ComputerCol, DeviceManufacturerCol,
      DeviceDescriptionCol, DeviceHWIDCol,
    ],
    'important': [
      DeviceManufacturerCol, DeviceDescriptionCol,
      DeviceHWIDCol, ExtraCol,
    ],
  }, {
    'name': 'FileOperation',
    'columns': [
      TimeCol, ComputerCol, UserCol, AppCol, FileOperationTypeCol, DeviceDescriptionCol, DriveTypeCol, AttachedFileNameCol,
    ],
    'important': [
      FileOperationTypeCol, AttachedFilePathCol, DeviceDescriptionCol, DriveTypeCol, FileOperationCol, ParentCol, AttachedFileNameCol
    ],
  }, {
    'name': 'Stat',
    'columns': [TimeCol, TypeCol, ComputerCol, UserCol, UserActiveCol, AppCol, DomainCol, TitleCol],
    'important': [AppCol, TitleCol, DomainCol, WebCol, UserActiveCol],
    'colwidths': [.1, .1, .1, .1, .1, .1, .1, .3]
  }, {
    'name': 'UserFeedback',
    'columns': [
      BacklinkCol, TimeCol, FeedbackCol, OwnerCol,
      UserCol, AmountCol, PriceCol, CommentCol,
    ],
    'important': [
      BacklinkCol, TimeCol, FeedbackCol, OwnerCol,
      UserCol, AmountCol, PriceCol, CommentCol,
    ],
  }, {
    'name': 'AttachedFile',
    'columns': [
      TimeCol, ComputerCol, UserCol, AppCol, RecipientsCol, AttachedFileCol, FileSizeCol, ParentCol,
    ],
    'important': [
      AttachedFileCol, ParentCol, RecipientsCol, FileSizeCol,
      FileOperationTypeCol, DeviceDescriptionCol, AttachedFileNameCol,
      AttachedFilePathCol, TextCol, DriveTypeCol,
    ],
    'colwidths': [.1, .1, .1, .1, .2, .2, .1, .1]
  }, {
    'name': 'SystemLog',
    'columns': [TimeCol, TypeCol, ComputerCol, TextCol, AttachedFileCol],
    'important': [AppCol, TextCol, AttachedFileCol],
  }, {
    'name': 'FrameBuffer',
    'columns': [TimeCol, ComputerCol, UserCol, AttachedFileCol],
    'important': [AttachedFileCol],
    'colwidths': [.1, .1, .1, .1]
  }, {
    'name': 'SearchQuery',
    'columns': [TimeCol, ComputerCol, UserCol, AppCol, SiteCol, TextCol],
    'important': [AppCol, SiteCol, TextCol, WebCol],
    'colwidths': [.1, .1, .1, .1, .1, .2]
  }, {
    'name': 'FormData',
    'columns': [
      TimeCol, ComputerCol, UserCol, AppCol,
      AttachedFileCol, DomainCol, ParentCol,
    ],
    'important': [
      AttachedFileCol, ParentCol, RecipientsCol,
      FileOperationTypeCol, DeviceDescriptionCol,
      DomainCol, TextCol, DriveTypeCol,
    ],
    'colwidths': [.1, .1, .1, .1, .3, .1, .1],
  }, {
    'name': 'WLan',
    'columns': [
      TimeCol, ComputerCol, WLanCol,
    ],
    'important': [
      WLanCol,
    ],
  }, {
    'name': 'Activty',
    'columns': [
      TimeCol, ComputerCol,
      UserCol, IdleTimeCol, FeedbackDescriptionCol
    ],
    'important': [
      ComputerCol, UserCol, IdleTimeCol,
      FeedbackDescriptionCol,
    ],
    'colwidths': [.1, .1, .1, .1, .2],
  }, {
    'name': 'TTY',
    'columns': [TimeCol, ComputerCol, UserCol, TitleCol, ScreenshotCol],
    'important': [AppCol, TitleCol, WebCol, ScreenshotCol],
    'colwidths': [.1, .1, .1, .2, .3],
  }, {
    'name': 'File',
    'columns': [TimeCol, ComputerCol, AttachedFilePathCol, AttachedFileNameCol, TextCol],
    'important': [ComputerCol, AttachedFilePathCol, AttachedFileNameCol, TextCol],
    'colwidths': [.1, .1, .3, .1, .3],
  }, {
    'name': 'Admin',
    'columns': [TimeCol, UserCol, TitleCol, TextCol],
    'important': [UserCol, TitleCol, TextCol],
    'colwidths': [.1, .1, .2, .6],
  }, {
    'name': 'LinuxLog',
    'columns': [TimeCol, TypeCol, ComputerCol, TextCol, AttachedFileCol],
    'important': [AppCol, TextCol, AttachedFileCol],
  }, {
    'name': 'RemoteLogon',
    'columns': [TimeCol, ComputerCol, UserCol, LogonCol],
    'important': [LogonCol],
  },
];

const tableViewByType = {
  '0': 'AttachedFile', //'AttachedFile',
  '1': 'Keyboard',
  '2': 'AppRun',
  '3': 'AppActiv',
  '4': 'Screenshot',
  '5': 'Net',
  '6': 'Install',
  '7': 'Web',
  '8': 'Im',
  '9': 'Mail',
  '11': 'PrintDoc',
  '12': 'Logon',
  '13': 'BaseTableOneEvet', //'Clipboard',
  '14': 'Device',
  '15': 'Device',
  '16': 'FileOperation',
  '17': 'SystemLog',
  '18': 'Activty',
  '19': 'UserFeedback',
  '20': 'WebcamSnapshot',
  '21': 'MicRecording',
  '22': 'FrameBuffer',
  '23': 'DevInventory',
  '24': 'Install2',
  '25': 'SearchQuery',
  '27': 'BaseTableOneEvet', // 'FormData',
  '28': 'WLan',
  '29': 'TTY',
  '30': 'File',
  '31': 'Admin',
  '33': 'LinuxLog',
  '34': 'RemoteLogon',
  '100500': 'Stat',
};

const otherColProperty = function(field, dim, fact) {
  const value = escapeHtml(fact[field]);
  return {
    fdim: dim,
    key: field,
    val: value,
    fval: value,
    flbl: value,
  };
};

const getColFromDims = (field, dims) => {
  const [pField, cField] = field.split('.');
  let label = false;
  let dimension = false;
  dims.some(dim => {
    if (dim.name === pField) {
      if (!cField) {
        dimension = `${pField}@default:${pField}`;
        label = dim.label;
        return label;
      }
      return dim.levels.some(l => {
        if (l.attributes && l.attributes.length > 1) {
          return l.attributes.some(attr => {
            if (attr.name === cField) {
              dimension = `${pField}@default:${pField}`;
              label = attr.label;
            }
            return label;
          });
        }
        if (l.key === cField) {
          label = l.label;
          dim.hierarchies.some(h => h.levels.some(hl => {
            if (hl === cField) {
              dimension = `${pField}@${h.name}:${cField}`;
              return true;
            }
          }));
        }
        return label;
      });
    }
    return false;
  });
  if (label) {
    const parse = ATTR2PROP[field] ? fact => cellFromProp(ATTR2PROP[field](fact)) :
      fact => cellFromProp(otherColProperty(field, dimension, fact));
    return {
      factKey: field,
      label,
      parse,
      sortable: unsortableFields.indexOf(field) === -1,
    };
  } else return null;
};

export function getTableViewByType(eventTypeId, filters, colFields, dims) {
  let tableView;
  if (colFields && colFields.length) {
    tableView = colFields.reduce((res, f) => {
      if (!tableViews.some(tw => {
          const i = tw.columns.findIndex(c => c.factKey === f);
          if (i === -1) return false;
          // console.log(tw.columns[i]);
          res.columns.push(tw.columns[i]);
          res.colwidths.push(tw.colwidths ? tw.colwidths[i] : 0.1);
          return true;
        })) {
        const col = getColFromDims(f, dims);
        if (col) {
          res.columns.push(col);
          res.colwidths.push(0.1);
        }
      }
      return res;
    }, {
      name: 'SelectedFields',
      columns: [],
      colwidths: [],
      important: []
    });
  } else {
    const viewTypeName = tableViewByType[eventTypeId] ?
      tableViewByType[eventTypeId] : 'BaseTable';
    tableView = $.grep(tableViews, tv => tv.name === viewTypeName)[0];
  }


  if (filters) {
    const skipCols = filters.reduce((p, f) => {
      if (f.dimension === 'agent_eventtype@default:agent_eventtype') {
        return p;
      }
      if (f.predicates && f.predicates.length) {
        return p;
      }
      p = p.concat(tableView.columns.filter(c =>
        c.dim === f.dimension && filters.reduce((cl, cf) =>
          cl + (f.dimension === cf.dimension ? 1 : 0), 0) === 1,
      ));
      return p;
    }, []);

    if (skipCols.length > 0) {
      const replaceTableView = {
        'name': tableView.name,
        'columns': tableView.columns.map(c => c),
        'important': tableView.important,
        'colwidths': tableView.colwidths ?
          tableView.colwidths.map(c => c) : undefined,
      };
      for (const s in skipCols) {
        const i = replaceTableView.columns.indexOf(skipCols[s]);
        replaceTableView.columns.splice(i, 1);
        if (replaceTableView.colwidths) {
          replaceTableView.colwidths.splice(i, 1);
        }
      }
      return replaceTableView;
    }
  }
  return tableView;
}

export function getBottomComponentHtml(fact) {
  const attrs2prop = ATTR2PROP;
  let widget2 = `<div id="id_bottom_${fact.id}" class="widget-properties show-waves">`;
  widget2 += Object.keys(attrs2prop).map(k => {
    if (fact && fact[k]) {
      const additionalElement = fact['agent_eventtype.name'] === 'InterceptedFile' && k == 'text_data' ? decoderElement() : '';
      return widgetFromProp(attrs2prop[k](fact, additionalElement));
    }
  }).join('', '');

  if (fact && fact.children) {
    widget2 += fact.children.map(ch => {
      ch['parentName'] = fact['agent_eventtype.name'];
      const linkToChildren = ch['id'] ? widgetFromProp(ATTR2PROP['children_id'](ch)) : '';
      return ch['agent_attachedfile.data'] ?
        widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) + linkToChildren : '';
    }).join('');
  }

  widget2 += '</div>';
  return widget2;
}



// WEBPACK FOOTER //
// ./src/facts/table-view.js